export class EmptyTranslationError extends Error {
  readonly name: string = 'EmptyTranslationError';
  constructor(localeId: string) {
    super(
      `Could not fetch the file content for ${localeId}, because of an empty response text. Please check data integrity on Smartling, if not the case... you probably do not want to pull files if your project empty`,
    );
  }
}
